export default "__VITE_ASSET__BHE7_W_S__"